import React, { useEffect, useState, useContext } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
    Button,
    InputLabel,
    Card
  } from "@material-ui/core";
  import TextField from '@material-ui/core/TextField';
  import axios from "axios";
  import AdminPartnerClient from '../../../Service/Admin/partner_services'
  import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions';
  import { BASE_URL } from "../../../constants.tsx";
import Tabs from "@material-ui/core/Tabs";
import { useHistory, useLocation } from "react-router";
import Tab from "@material-ui/core/Tab";
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import HeaderMenu from "../../../Components/HeaderMenu";
import BannerImage from "../../../Images/TealRefquestionnaire.png";
import Paper from "@material-ui/core/Paper";
import DataService from "../../../Service";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select/Select";
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import CustomInput from "../../../Components/CustomInput";
import CustomSelect from "../../../Components/CustomSelect";
import { useParams } from "react-router-dom";
import DataClient from "../../../Service/general_data_service";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import MenuItem from '@material-ui/core/MenuItem';

import { useSelector, useDispatch } from "react-redux";
const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
    textTransform: 'none',

    // justifyContent:'space-around'
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  bannerStyle:{
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1301,
    position: "sticky"
    },
  // padding: {
  //   padding: theme.spacing(3),
  // },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    position: "absolute",
    top: "35%",
    marginLeft: "11%",
    // marginBottom:'25px',
    width: "80.6%",
    // padding: "5%",
  },
  statsBoard:{
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between',
    padding:theme.spacing(2),
    width:'17%',
    borderLeft: 'solid #3B86FF'
    // borderColor:'#56D9FE'
},
stepperButtons: {
  position: "fixed",
  display: "flex",
  justifyContent: "space-between",
  bottom: "4%",
  backgroundColor: "white",
  padding: "10px 0px 20px 0px",
  paddingLeft:"8px",
  zIndex: 1,
},
  demo2: {
    // backgroundColor: "#2e1534",
    position: "absolute",
    top: "38.1%",
    marginLeft: "134px",
    width: "84%",
    marginTop:'25px'
    // padding:'5px'
    // height: "100%",
  },
}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  let sectionId = '';
  let crfFromId = ''
  function a11yProps(index,item) {
     sectionId = item.id;
     crfFromId = item.coaching_request_form_id;
    //   setCrfSectionId(item.id)
    //   setCrfFormId(item.coaching_request_form_id)
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }
export default function CustomizedTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfAnswers, setCrfAnswers] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [userData, setUserData] = useState();
  const history = useHistory();

  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showCrfList, setShowCrfList] = useState(false);
  const [currentSelectionField, setCurrentSelectionField] = useState({});
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [crfValue, setCrfValue] = useState([]);
  const [fieldAction, setFieldAction] = useState(null);
  const [totalCount, setTotalCount] = useState(100);
  const [crfUserId, setCrfUserId] = useState("");
  const [crfFormId, setCrfFormId] = useState("");
  const [crfId, setCrfId] = useState('');
  let { slug } = useParams();
  const [answerData, setAnswerData] = useState({});
  let quesArr = []
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const urlParams =
  typeof window !== `undefined` &&
  new URLSearchParams(window.location.search);
  
  let search = window.location.search;
let params = new URLSearchParams(search);
let queryString1 = params.get('slug');

// const EmpID = sessionStorage.getItem("employee_id");
// console.log(`sessionStorage.getItem("employee_id")`, sessionStorage.getItem("employee_id"))
const bodyParameters = {
 key: "value"
};
const queryString =
typeof window !== "undefined" ? window.location.href.split("?")[1] : "";

const queryStringEmail =
typeof window !== "undefined" ? window.location.href.split("/")[6] : "";

const [focusText, setFocusText] = useState("1");
const [quesData, setQuesData] = useState({});

  const orgId = localStorage.getItem("organisation_id")
const handleChangeData =(fieldId)=>{
}
  const setInputState = (inputStateValue, inputId) => {
    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const setQuestionChangeState = (selectedItemValue, inputId) => {
    setUserData({ ...userData, [selectedItemValue]: selectedItemValue });
    setAnswerData({ ...answerData, [inputId]: selectedItemValue });
    (inputId == "Business Experience") && setUserData({ ...userData, "ref4": selectedItemValue.value })
};

const Programmes = () => {
  const statusData={
    id:queryString
  }
  
  DataService.getDirectData(
    `partner_reference_qas/reference_slug?${queryString}`
    
  ).then((res) => {
    setTotalCount(res["total_count"]);
    // if(res.success){
    if (res.question_answers && res.question_answers.length > 0) {
      let CoachinRates = res.question_answers;
      setModuleSetups(CoachinRates);
    }
    setLoading(false);
  });
};
var EmailValue = queryString.substring(queryString.indexOf("&"));

let finalEmailValue = EmailValue.substring(EmailValue.indexOf("="));

let finalEmailValue1 = finalEmailValue.replace("=","");
let finalEmailValue2 = finalEmailValue.substring(finalEmailValue.indexOf("&"));
let finalEmailValue3 = finalEmailValue2.substring(finalEmailValue2.indexOf("="));
let FilteredEmail = finalEmailValue1.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
let partnerName = finalEmailValue3.replace("=","");

// console.log('finalEmailValue', finalEmailValue3,finalEmailValue2,finalEmailValue1,FilteredEmail.toString())
const global_data = useSelector((state) => state.stepperReducer);
const global_data_common = useSelector((state) => state.commonReducer);
// var quesArr = []
const handleSubmit = () => {
    var flag = true;
    // if (userData.internal_notes == "") {
    //     flag = false;
    // }
  

    if (flag) {
        setSubmitClickFlag(false)
        setLoading(true)
        for (var i in quesData) {
            quesArr.push({ question_id: i, answer: quesData[i] })
        }
        if (global_data.partner_reference_ques_id == null) {
            AdminPartnerClient.ReferenceQuestionnaireSlug({
                slug: queryString1,
                email:FilteredEmail.toString(),
                question_answers: quesArr,
            }).then((response) => {
              if(response.success){
                dispatch(showSnackbar("Success", ["Information saved successfully"]))
              // setTimeout(() => {

              //   history.push(`/auth/login`)
              // }, 5000)
              history.push({ pathname: `/partnercknowledgement` })

                dispatch({ type: GLOBAL_STEPPER_DATA, payload: { partner_reference_ques_id: response.data[response.data.length - 1].id } });
                props.parentHandleNext(props.activeIndex + 1)
                setLoading(false)
              }
            }).catch(() => { setLoading(false) });
        } else {
            AdminPartnerClient.ReferenceQuestionnaire_put(global_data.partner_reference_ques_id, (
                {
                    slug: queryString1,
                    question_answers: quesArr,
                }
            )).then((response) => {
              if(response.success){
                history.push({ pathname: `/partnercknowledgement` })

                dispatch(showSnackbar("Success", ["Information saved successfully"]))
                history.push(`/auth/login`)

                props.parentHandleNext(props.activeIndex + 1)
                setLoading(false)
              }
            }).catch(() => { setLoading(false) });
        }
        // props.parentHandleNext(props.activeIndex + 1)
    } else {
        setSubmitClickFlag(true)
    }

}
// const handleSubmit = () => {
//     for (var i in answerData) {
//         quesArr.push({ question_id: i, answer: answerData[i] })
//     }
//     const statusData={
       
//         question_answers: JSON.stringify(quesArr),
//         slug:queryString
//       }
//       DataService.createData(statusData, "partner_reference_qas")
//     .then((res) => {
//       // CrfFetch()
//       // if (res.success) {  
//         let crfUserId = res.coaching_request_form.crf_user_id;
//         setCrfUserId(crfUserId)
//         if((value + 1) < CoachinRequest.length )  {
      
//         setValue(value + 1)
//         dispatch(showSnackbar("success", ["Success!"]));
//       } 
//       dispatch(showSnackbar("success", ["Success!"]));
//       // FetchCrfAnswer()
//     })
//     .catch((err) => {
//       // setLoading(false);
//       dispatch(showSnackbar("error", [["" + err.errors]]));
//     });
//   };
  useEffect(() => {
    // setLoading(true);
    // CrfFetch();
    Programmes()
    // FetchCrfAnswer()
  }, []);
  const setQuestionInputState = (inputStateValue, inputId) => {
    setQuesData({ ...quesData, [inputId]: inputStateValue });
    (inputId == "Business Experience") && setAnswerData({ ...userData, "ref1": inputStateValue });
    (inputId == "What were your observation as to her/his contribution to the achievement of your objectives") && setAnswerData({ ...userData, "ref2": inputStateValue });
    (inputId == "How would you describe their professionalism and effectiveness") && setAnswerData({ ...userData, "ref3": inputStateValue });
    (inputId == "Any other comments") && setAnswerData({ ...userData, "ref5": inputStateValue });

}

  return (
    <div>
   
      <img
        src={BannerImage}
        // style={{ position: "relative" }}
        alt={BannerImage}
        className={classes.bannerStyle}
        width="100%"
      />
      
<div className={classes.root}>
<Grid container direction="row" alignItems="center" style={{ padding: 30, marginBottom: 30 }}>
                <Grid item xs={10}>
                    <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant={focusText == '1' ? "elevation" : "outlined"} style={{ padding: 10, border: (focusText == '1') ? '0px solid #3B86FF' : '', borderLeftWidth: (focusText == '1') ? '5px' : "1px" }}>
                            <Typography variant="h5" className={classes.labelText} style={{ marginBottom: 5 }}>Business experience</Typography>
                            <CustomInput multiline rows={6} id="Business experience" placeholder="Free Text" parentcall={setQuestionInputState} onClick={() => setFocusText('1')}  />
                        </Card>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant={focusText == '2' ? "elevation" : "outlined"} style={{ padding: 10, border: (focusText == '2') ? '0px solid #3B86FF' : '', borderLeftWidth: (focusText == '2') ? '5px' : "1px" }}>
                            <Typography variant="h5" className={classes.labelText} style={{ marginBottom: 5 }}>What were your observation as to her/his contribution to the achievement of your objectives?</Typography>
                            <CustomInput multiline rows={6}  id="What were your observation as to her/his contribution to the achievement of your objectives" placeholder="Free Text" parentcall={setQuestionInputState} onClick={() => setFocusText('2')} />
                        </Card> </Grid>
                    <Grid item xs={12} style={{ marginBottom: 30 }}>
                    <Card variant={focusText == '3' ? "elevation" : "outlined"} style={{ padding: 10, border: (focusText == '3') ? '0px solid #3B86FF' : '', borderLeftWidth: (focusText == '3') ? '5px' : "1px" }}>
                        <Typography variant="h5" className={classes.labelText} style={{ marginBottom: 5 }}>How would you describe their professionalism and effectiveness?</Typography>
                        <CustomInput multiline rows={6}  id="How would you describe their professionalism and effectiveness"  placeholder="Free text" onClick={() => setFocusText('3')} parentcall={setQuestionInputState}  />
                        </Card>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Typography variant="h5" className={classes.labelText} style={{ marginBottom: 5 }}>Was {partnerName} supportive and challenging?</Typography>
                        <CustomSelect labelText={`Select Was ${global_data_common.name} supportive and challenging?`} id="Was 'coach:name' supportive and challenging" displayEmpty variant="outlined" itemArr={['Yes', 'No']} parentcall={setQuestionChangeState} 
                         />
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: 30 }}>
                        <Card variant={focusText == '3' ? "elevation" : "outlined"} style={{ padding: 10, border: (focusText == '4') ? '0px solid #3B86FF' : '', borderLeftWidth: (focusText == '4') ? '5px' : "1px" }}>
                            <Typography variant="h5" className={classes.labelText} style={{ marginBottom: 5 }}>Any other comments</Typography>
                            <CustomInput multiline rows={6}  id="Any other comments" placeholder="Free Text" parentcall={setQuestionInputState} onClick={() => setFocusText('4')}  />
                        </Card>
                    </Grid>
                </Grid>
                <Grid item xs={10}></Grid>
                    <Grid item xs={2}>
                      <div className={classes.stepperButtons}>
                        <Button
                          disableElevation
                          disabled={loading}
                          variant="contained"
                          color="primary"
                          className={classes.btnSearch}
                          onClick={handleSubmit}
                        >
                          {/* {loading && (
                            <CircularProgress
                              className={classes.circularProgress}
                              size={20}
                            />
                          )} */}
                          {value + 1 === CoachinRequest.length
                            ? "Submit"
                            : "Submit"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
       
            {/* <Button style={{margin:"30px",marginTop:"2px"}} disableElevation  variant="contained" color="primary" className={classes.btnSearch}
                                                onClick={handleSubmit}
                                            >
                                            {'Submit' }
                                    </Button>   */}
            {/* <Button saveBtnTitle={'Save & Proceed'} isBack={true} parentcall={onSubmit} parentBackCall={onBack} /> */}
      
    </div>
    </div>
  );
}


